import React from "react";
import TopNav from "./TopNav";
import CommonTableComp from "./Table";

const CommonListItemsComp = (props) => {
  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <TopNav {...props} />
          <CommonTableComp {...props} />
        </div>
      </div>
    </>
  )
}

export default CommonListItemsComp;